import {CustomBreadCrumStyle, CustomClassName, CustomStyle} from './CustomStyles'
import {ReactNode} from 'react'
import {Link, useNavigate} from 'react-router-dom'


type CustomBreadCrumbProps = {
  title: string;
  button?: string;
  isDashboard: boolean;
  isReport: boolean;
}
type CustomReportBreadcrumbProps = {
  title: string;
  button?: string;
}
const CustomBreadCrumb = ({ button, title, isDashboard, isReport}:CustomBreadCrumbProps) => {
  const navigate = useNavigate()
  return (
    <div
      style={
        CustomBreadCrumStyle
      }
      className={CustomClassName}
    >
      <h3
        style={{
          paddingBottom: '20px',
          paddingRight: '10px',
        }}
      >
        {title}
      </h3>
      <span>
        |
      </span>
      {
        isReport ?
          <a
            style={{
              paddingLeft: '10px',
              cursor: 'pointer',
            }}
            className="text-muted text-hover-primary fs-6 fw-bold"
            onClick={() => navigate(-1)}>Go Back
          </a> :
          <span
            style={{
              paddingLeft: '10px',
            }}
          >
            <Link
              to={'/landing'}
              className="text-muted text-hover-primary fs-6 fw-bold"
            >
              {isDashboard ? 'DASHBOARDS' : 'REPORTS'}
            </Link>
          </span>

        }


    </div>
  );
}


export default CustomBreadCrumb
